import type { EntityUpgradesList } from '../../types/game-types';
import { useCurrencyStore } from '../zustand/useCurrencyStore';

/** Tick inspiration timers in Zustand (currency store is the source of truth). */
export const manageInspirationReducer = (upgrades: EntityUpgradesList) => {
  const currency = useCurrencyStore.getState();
  const inspiration = { ...currency.inspiration };
  const previousActive = inspiration.remainingActive;
  const nextActive = Math.max(0, inspiration.remainingActive - 1);
  let nextCooldown = Math.max(0, inspiration.remainingCooldown - 1);

  let nextMultiplier = inspiration.multiplier;

  if (previousActive > 0 && nextActive === 0) {
    nextMultiplier = 1;

    // Base cooldown is controlled by the Bard's Encore upgrade.
    // Starts at 60 and is reduced by 1 for every Encore level purchased,
    // with the current value stored in the upgrade's multiplier.
    const encoreUpgrade = upgrades.bard?.encore;
    const encoreCooldown = encoreUpgrade?.multiplier ?? 60;

    nextCooldown = encoreCooldown;
  }

  useCurrencyStore.getState().sync({
    inspiration: {
      ...inspiration,
      multiplier: nextMultiplier,
      remainingActive: nextActive,
      remainingCooldown: nextCooldown,
    },
  });
};
